import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  img:{
    alignSelf: 'center',
    justifySelf: 'center',
    width: 600
  },

}));
